import { Injectable, inject } from '@angular/core';
import { AppActions } from '@navfleet/client/core/app';
import { LicenseFacade } from '@navfleet/client/license/domain/data-access';
import { License } from '@navfleet/client/license/domain/models';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { MapSafetySarApi } from '../api/map-safety-sar.api';
import { MapSafetySarActions } from './map-safety-sar.actions';

@Injectable()
export class MapSafetySarEffects {
    private readonly actions$ = inject(Actions);
    private readonly api = inject(MapSafetySarApi);
    private readonly licenseFacade = inject(LicenseFacade);

    public readonly loadSarData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AppActions.loadAppData),
            this.licenseFacade.hasRequiredLicensesFilter({
                allRequired: [License.NavtorDataLayers],
                noneRequired: [License.Viewer],
            }),
            map(() => MapSafetySarActions.loadSAR())
        )
    );

    public readonly loadSarDataResult$ = createEffect(() =>
        this.actions$.pipe(
            ofType(MapSafetySarActions.loadSAR),
            this.licenseFacade.hasRequiredLicensesFilter({
                allRequired: [License.NavtorDataLayers],
                noneRequired: [License.Viewer],
            }),
            switchMap(() =>
                this.api.get().pipe(
                    map(({ contactTypes, lastUpdated }) =>
                        MapSafetySarActions.loadSARSuccess({ contactTypes, lastUpdated })
                    ),
                    catchError((error) => of(MapSafetySarActions.loadSARFailure({ error })))
                )
            )
        )
    );
}
